import { Component } from '@angular/core';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  languages = [
    { code: 'en', label: 'English', flag: 'assets/flags/en.jpg' },
    { code: 'fr', label: 'Français', flag: 'assets/flags/fr.jpg' },
    { code: 'it', label: 'Italiano', flag: 'assets/flags/it.jpg' },
    { code: 'de', label: 'Deutsch', flag: 'assets/flags/de.jpg' },
  ];

  currentLang = 'en';
  currentFlag = 'assets/flags/en.jpg';

  constructor(private langService: LanguageService) {
    this.langService.selectedLang.subscribe((lang) => this.setLanguage(lang));
  }

  changeLanguage(lang: string) {
    this.langService.setLanguage(lang);
  }

  private setLanguage(lang: string) {
    this.currentLang = lang;
    const selected = this.languages.find((l) => l.code === lang);
    this.currentFlag = selected ? selected.flag : 'assets/flags/en.jpg';
  }
}
